import { useNavigate, useLocation, useParams } from 'react-router';
export const withRouter = (Component) => (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  return (
    <Component
      {...props}
      navigate={navigate}
      location={location}
      params={params}
    />
  );
};
